module.exports = __webpack_public_path__ + "img/baato2.5e2b2427.png";